<template>
    <div class="t-container article">
        <div style="text-align: center; font-size: 35px; color: rgb(199 0 11); font-weight: 600; padding-top: 20px;"><span>{{ $i18n.t(`aboutHWT.eight.content1`) }}</span></div>
        &nbsp;
        <p class="text article-content">{{ $i18n.t(`aboutHWT.eight.content2`) }}</p>
        <p class="text article-content">{{ $i18n.t(`aboutHWT.eight.content3`) }}</p>
    </div>
</template>

<script>
export default {
name: 'cp8',
}
</script>

<style lang="less" scoped>
.article {
    padding: 0 24px 16px;
      padding-bottom: 150px;
  
      .article-title {
      font-size: 40px;
      font-weight: 400;
      color: #000000;
      text-align: center;
      padding: 50px 0 40px;
      span {
          // border-bottom: 2px solid rgb(199 0 11);
          display: block;
          font-size: 28px;
          font-weight: 600;
      }
      }
  
      .article-content {
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      line-height: 2.0;
      }
  }
</style>